import * as XLSX from 'xlsx';

export interface ParsedDeviceImportXlsx {
  imeis: string[];
  /** Värde från Excel B2 (första data-radens kablar), om giltigt heltal */
  cableCount: number | null;
}

function cellImeiDigits(cell: XLSX.CellObject | undefined): string | null {
  if (!cell || cell.v === '' || cell.v === undefined || cell.v === null) return null;
  const w = cell.w != null && String(cell.w).trim() !== '' ? String(cell.w).trim() : '';
  const fromW = w.replace(/\s/g, '').replace(/\D/g, '');
  if (/^\d{14,16}$/.test(fromW)) return fromW;
  const raw = String(cell.v).trim().replace(/\s/g, '');
  const digits = raw.replace(/\D/g, '');
  if (/^\d{14,16}$/.test(digits)) return digits;
  return null;
}

/**
 * Läser första bladet: kolumn A = IMEI (alla rader utom ev. rubrik "imei"),
 * cell B2 = kablar (första data-rad enligt mall).
 */
export function parseDeviceImportXlsx(data: ArrayBuffer): ParsedDeviceImportXlsx {
  const wb = XLSX.read(data, { type: 'array', cellDates: false });
  const name = wb.SheetNames[0];
  const ws = name ? wb.Sheets[name] : undefined;
  if (!ws) return { imeis: [], cableCount: null };

  const b2 = ws.B2 as XLSX.CellObject | undefined;
  let cableCount: number | null = null;
  if (b2 != null && b2.v !== '' && b2.v !== undefined && b2.v !== null) {
    const raw =
      typeof b2.v === 'string'
        ? b2.v.replace(/\s/g, '').replace(',', '.')
        : String(b2.v);
    const n = Number(raw);
    if (Number.isFinite(n) && n >= 0 && Math.floor(n) === n) {
      cableCount = Math.min(4_294_967_295, n);
    }
  }

  const ref = ws['!ref'];
  if (!ref) return { imeis: [], cableCount };

  const range = XLSX.utils.decode_range(ref);
  const seen = new Set<string>();
  const imeis: string[] = [];

  for (let R = range.s.r; R <= range.e.r; R++) {
    const addr = XLSX.utils.encode_cell({ r: R, c: 0 });
    const cell = ws[addr] as XLSX.CellObject | undefined;
    const digits = cellImeiDigits(cell);
    if (!digits) continue;
    if (/^imei$/i.test(String(cell?.w || cell?.v || '').trim())) continue;
    if (!seen.has(digits)) {
      seen.add(digits);
      imeis.push(digits);
    }
  }

  return { imeis, cableCount };
}
